module.exports = __webpack_public_path__ + "static/media/Kystledlogo.6faa7d27.png";